module.exports = __webpack_public_path__ + "img/setting-step-four.a41a0f03.png";